const logs = {
    page_title: 'Audit logs',
    title: 'Audit logs',
    subtitle: 'Anzeige der Log Daten von Authentifizierungsereignissen, die von Admins und Benutzern stammen',
    event: 'Event',
    user: 'Benutzer',
    application: 'Anwendung',
    time: 'Zeit',
    filter_by: 'Filter nach',
    last_1_hour: 'Letzte Stunde',
    last_24_hours: 'Letzte 24 Stunden',
    last_7_days: 'Letzte 7 Tage',
    last_30_days: 'Letzte 30 Tage',
    custom_range: 'Benutzerdefiniert',
    from: 'Von',
    to: 'Bis',
};
export default Object.freeze(logs);
